<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onEditAndSaveClick)="doEditAndSave($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4">
      <div class="flex">
        @if(srv.isEditing()){
        <app-jktext label="使用者代號" [value]="item.SA003">
        </app-jktext>
        <label> (KEY欄位不可修改!只能刪除再新增!)</label>
        }@else{
        <app-jkbtnedit [label]="'使用者代號'" [maintable]="'ADMMF'" [item]="'W01'" [(value)]="item.SA003" [keyfield]="true"
          [state]="srv.state" [valueExpr]="'MF001'" [readonly]="srv.isEditing()" [width]="'60'" [readonly]="isBrowse"
          [displayExpr]="'MF002'"></app-jkbtnedit>
        }
      </div>
      <app-jktextarea height="250px" label="備註" #SA005Com id="SA005" [(value)]="item.SA005" placeholder="備註"
        [readonly]="isBrowse">
      </app-jktextarea>
      <app-jktext label="主資料表" #SA001Com id="SA001" [value]="item.SA001" [required]="true" placeholder="主資料表">
      </app-jktext>
      <app-jktext label="序號" [value]="item.SA002">
      </app-jktext>

    </div>
  </div>
</div>